export default {
  allPendingReleases: [],
}
